import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
export { MinimizedWidgets } from './widgets';
export function WidgetSelection() {
    const [widgets, placementManager] = Common.useWidgets();
    const overlay = Common.useOverlay();
    function showWidget(widget) {
        placementManager.showWidget(widget.id);
        overlay.setOverlay({ type: Common.OverlayType.Null });
    }
    return (_jsx(_Fragment, { children: _jsx(Components.BtnGroup, { children: widgets.map(widget => (_jsx(Components.Button, { onClick: () => showWidget(widget), children: _jsx(Common.MLT, { text: widget.title }) }, widget.id))) }) }));
}
